import { render, staticRenderFns } from "./HelloWorldPage4.vue?vue&type=template&id=1c86ce97&"
import script from "./HelloWorldPage4.vue?vue&type=script&lang=ts&"
export * from "./HelloWorldPage4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports